module.exports = __webpack_public_path__ + "img/qy_code.71656306.png";